import { ActionModel } from "./../../model/application/action";
import {
  RegistrationPage,
  MerchantCategories,
  MerchantProducts,
  MerchantComission,
  MerchantRoles,
  MerchantUser,
  MerchantDashboard,
  MerchantWallet,
  MerchantReport,
  AuditLog,
  MerchantProfile,
  UserAuthentication,
  Transaction,
  BulkAirtime,
} from "../action/merchant";
import { MerchantThunkService } from "./../thunk/merchant";
import { MerchantBillers } from "./../action/merchant";
import { MerchantSetting } from "../action/merchant";

export class MerchantStateReducer {
  static RegistrationPage(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case RegistrationPage.Set_Registration_Page_State:
        return action.payload;
      case RegistrationPage.Validate_User:
        MerchantThunkService.ValidateUser(() => {}, action.payload);
        return action.payload;
      case RegistrationPage.Logged_In_User:
        MerchantThunkService.ValidateLoggedInUser(() => {}, action.payload);
        return action.payload;
      case RegistrationPage.Create_Merchant:
        MerchantThunkService.CreateMerchant(action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static merchantDashboard(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case MerchantDashboard.Set_Merchant_Dashboard_State:
        return action.payload;
      case MerchantDashboard.Get_Merchant_Dashboard_State:
        MerchantThunkService.DashboardStatistics(action.payload);
        return action.payload;
      case MerchantDashboard.Set_GetMerchant_DashboardBalance_State:
        MerchantThunkService.GetBalance(action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static LandingPage(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case UserAuthentication.SET_USER_AUTHENTICATION:
        return action.payload;
      case UserAuthentication.GET_USER_AUTHENTICATION:
        MerchantThunkService.AuthenticateUser(action.payload);
        return action.payload;
      case UserAuthentication.GET_USER:
        MerchantThunkService.ValidateUser(() => {}, action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static Categories(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case MerchantCategories.Set_Merchant_Category_State:
        return action.payload;
      case MerchantCategories.Set_GetMerchant_Category_State:
        MerchantThunkService.GetCategory(action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static Roles(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case MerchantRoles.Set_Merchant_Role_State:
        return action.payload;
      case MerchantRoles.Set_GetMerchant_Role_State:
        MerchantThunkService.GetRoles(() => {}, action.payload);
        return action.payload;
      case MerchantRoles.Create_Role:
        MerchantThunkService.CreateRoles(action.payload);
        return action.payload;
      case MerchantRoles.Set_GetMerchant_Permission_State:
        MerchantThunkService.GetPermissions(action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static Users(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case MerchantUser.Set_Merchant_User_State:
        return action.payload;
      case MerchantUser.Set_GetMerchant_User_State:
        MerchantThunkService.GetUser(action.payload);
        return action.payload;
      case MerchantUser.Create_Merchant_User:
        MerchantThunkService.CreateUser(action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static Billers(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case MerchantBillers.Set_Merchant_Biller_State:
        return action.payload;
      case MerchantBillers.Set_GetMerchant_Biller_State:
        MerchantThunkService.GetBiller(action.payload);
        return action.payload;
      case MerchantBillers.Add_Biller:
        MerchantThunkService.AddMoreBillers(action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static MerchantCommission(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case MerchantComission.Set_Merchant_Commission_State:
        return action.payload;
      case MerchantComission.Set_GetMerchant_Commission_State:
        MerchantThunkService.GetMerchantCommission(action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static Products(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case MerchantProducts.Set_Merchant_Product_State:
        return action.payload;
      case MerchantProducts.Set_GetMerchant_Product_State:
        MerchantThunkService.GetProduct(action.payload);
        return action.payload;
      case MerchantProducts.Filter_Product:
        MerchantThunkService.FilterProduct(() => {}, action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static Settings(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case MerchantSetting.Set_Merchant_KeySettings_State:
        return action.payload;
      case MerchantSetting.Set_GetMerchant_KeySettings_State:
        MerchantThunkService.GetKey(action.payload);
        return action.payload;
      case MerchantSetting.Wallet_Alert:
        MerchantThunkService.UpdateWalletAlert(() => {}, action.payload);
        return action.payload;
      case MerchantSetting.View_Wallet_Limit:
        MerchantThunkService.ViewWalletLimit(() => {}, action.payload);
        return action.payload;
      case MerchantSetting.Change_Pin:
        MerchantThunkService.ChangeTransactionPin(action.payload);
        return action.payload;
      case MerchantSetting.Reset_Pin:
        MerchantThunkService.ResetTransactionPin(action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static Wallet(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case MerchantWallet.Set_Merchant_WalletTransaction_State:
        return action.payload;
      case MerchantWallet.Set_GetMerchant_WalletTransaction_State:
        MerchantThunkService.GetDashboardBalance(action.payload);
        return action.payload;
      case MerchantWallet.Get_Wallet_Commission:
        MerchantThunkService.GetWalletCommission(action.payload);
        return action.payload;
      case MerchantWallet.Transfer_Commission:
        MerchantThunkService.TransferCommission(action.payload);
        return action.payload;
      case MerchantWallet.Filter_WalletTransaction:
        MerchantThunkService.FilterWallet(action.payload);
        return action.payload;
      case MerchantWallet.Filter_WalletTransactionCommission:
        MerchantThunkService.FilterWalletCommission(action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static Report(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case MerchantReport.Set_Merchant_Report_State:
        return action.payload;
      case MerchantReport.Set_GetMerchant_Report_State:
        MerchantThunkService.GetReport(action.payload);
        return action.payload;
      case MerchantReport.Filter_Report:
        MerchantThunkService.FilterReport(action.payload);
        return action.payload;
      case MerchantReport.Get_Receipt:
        MerchantThunkService.GetReceipt(action.payload);
        return action.payload;
      case MerchantReport.SEND_DAILY_REPORT:
        MerchantThunkService.SendDailyReports(action.payload);
        return action.payload;
      case MerchantReport.GET_MERCHANT_SETTLEMENTS:
        MerchantThunkService.GetMerchantSettlement(action.payload);
        return action.payload;
      case MerchantReport.FILTER_SETTLEMEMT:
        MerchantThunkService.FilterSettlement(action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static AuditLog(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case AuditLog.Set_Audit_Logs:
        return action.payload;
      case AuditLog.Get_Audit_Logs:
        MerchantThunkService.AuditLogs(action.payload);
        return action.payload;
      case AuditLog.Filter_Audit_Logs:
        MerchantThunkService.FilterAuditLog(action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static MerchantProfile(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case MerchantProfile.SET_MERCHANT_PROFILE_STATE:
        return action.payload;
      case MerchantProfile.GET_KYC_TIER:
        MerchantThunkService.GetKycTier(action.payload);
        return action.payload;
      case MerchantProfile.UPDATE_MERCHANT_PROFILE:
        MerchantThunkService.UpdateMerchantProfile(action.payload);
        return action.payload;
      case MerchantProfile.GET_MERCHANT_PROFILE_STATE:
        MerchantThunkService.GetMerchantProfile(action.payload);
        return action.payload;
      case MerchantProfile.SUBMIT_KYC:
        MerchantThunkService.submitKyc(action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static Transaction(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case Transaction.SET_TRANSACTION:
        return action.payload;
      case Transaction.GET_TRANSACTION_CATEGORY:
        MerchantThunkService.GetTransactionCategory(action.payload);
        return action.payload;
      case Transaction.GET_TRANSACTION_BILLER:
        MerchantThunkService.GetTransactionBiller(action.payload);
        return action.payload;
      case Transaction.GET_TRANSACTION_PRODUCT:
        MerchantThunkService.GetTransactionProduct(action.payload);
        return action.payload;
      case Transaction.PERFORM_ACTION:
        MerchantThunkService.MakePayment(action.payload);
        return action.payload;
      case Transaction.PIN_VERIFICATION:
        MerchantThunkService.PinVerification(action.payload);
        return action.payload;
      case Transaction.CREATE_PIN:
        MerchantThunkService.CreateTransactionPin(action.payload);
        return action.payload;
      case Transaction.CUSTOMER_LOOK_UP:
        MerchantThunkService.LookUp(action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static BulkAirtime(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case BulkAirtime.SET_BULK_AIRTIME:
        return action.payload;
      case BulkAirtime.GET_BULK_AIRTIME:
        MerchantThunkService.GetAllBulkAirtime(action.payload);
        return action.payload;
      case BulkAirtime.GET_SINGLE_BULK_AIRTIME:
        MerchantThunkService.GetSingleBulkAirtime(action.payload);
        return action.payload;
      case BulkAirtime.BULK_UPLOAD:
        MerchantThunkService.UploadBulk(action.payload);
        return action.payload;
      default:
        return state;
    }
  }
}
